module.exports = __webpack_public_path__ + "static/media/SLU.e717f1b7.jpg";